import { useMemo } from 'react';
import { groupBy } from 'fp-ts/NonEmptyArray';
import { Product } from '@mews-commander/data-access';
import { useProductsQuery } from '@mews-commander/legacy-entities/src/queries/productsQuery';

const groupProductsByServiceId = groupBy<Product>((p) => p.serviceId);

export const useProductsByService = (serviceIds: string[] | undefined) => {
    const productsQuery = useProductsQuery(
        { serviceIds, extent: { baseProducts: false, productCategories: true } },
        { enabled: !!serviceIds?.length }
    );

    return useMemo(
        () => ({
            productsByService: groupProductsByServiceId(productsQuery.data?.products ?? []),
            productCategories: productsQuery.data?.productCategories,
            loading: productsQuery.isFetching,
        }),
        [productsQuery.data, productsQuery.isFetching]
    );
};
